import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function VowQuizLogo({ width = 40, height = 40, className = '' }: LogoProps) {
  return (
    <img 
      src="/vowquizlogo.png" 
      alt="Vow Quiz Logo" 
      width={width} 
      height={height}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}